var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-navbar',{staticClass:"header-class",attrs:{"type":"light"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('i',{class:{
          'bx bx-menu': !_vm.isMenuOpen,
          'bx bx-menu-alt-right': _vm.isMenuOpen,
        },attrs:{"id":"btn"},on:{"click":_vm.toggleMenu}}),_vm._v(" RWM ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }